import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ControlService } from '../control/control.service';
import { IRtuControlModel } from '../shared/models/models';
import { CopyToService } from './copy-to.service';

@Component({
    selector: 'dl-copy-to',
    templateUrl: './copy-to.component.html',
    styleUrls: ['./copy-to.component.scss']
})
export class CopyToComponent implements OnInit {
    public static $name: string = 'copyTo';

    @Input() public currentHardwareId: number;
    @Input() public locationId: number;

    /** The list of non-selected RTUs, to use to build the list of choices */
    @Input() public nonSelectedRtus: IRtuControlModel[];

    /** Stores the ids of the items selected by the multiselect control */
    selectedRtus: string[] = [];

    isVisible: boolean;

    copyToForm: FormGroup;
    formControl: FormControl;

    constructor(
        private controlService: ControlService,
        private copyToService: CopyToService,
    ) {
    }

    public ngOnInit() {
        this.copyToForm = new FormGroup({});
        this.formControl = new FormControl(this.selectedRtus);
        this.copyToForm.addControl('selectedRtus', this.formControl);
        this.formControl.valueChanges.subscribe(selectedRtus => {
            this.selectedRtus = selectedRtus;
        });
    }

    toggle(): void {
        this.isVisible = !this.isVisible;
    }

    submit(): void {
        this.controlService.broadcastMultipleCardStatusUpdate(this.locationId, this.selectedRtus, 'Submitting');

        this.copyToService.copyScheduleToSelectedRTUs(this.currentHardwareId, this.selectedRtus).then(() => {
            this.selectedRtus = [];
            this.toggle();
        });
    }
}
